var external = function () {

  var publicMethods = {};

  var elements = document.querySelectorAll('.js-external');

	var htmlElement = document.querySelector('html');

  publicMethods.init = function() {

    if (!elements.length) return;
    
    for (var i = 0; i < elements.length; i++) {
			
			(function (i) {
				
				elements[i].addEventListener('click', handleExternalClick);

			})(i);
		
		}

  };

  function handleExternalClick(e) {

		var target = e.target;

		if (htmlElement.classList.contains('touchevents') || matchMedia('(max-width: 639px)').matches) return;

		var w = target.getAttribute('data-width') ? parseInt(target.getAttribute('data-width'), 10) : 640;
		var h = target.getAttribute('data-height') ? parseInt(target.getAttribute('data-height'), 10) : 480;
		var l = Math.round((window.innerWidth - w) / 2);
		var t = Math.round((window.innerHeight - h) / 2);
		window.open(target.getAttribute('href'), 'Popup', 'width=' + w + ',height=' + h + ',left=' + l + ',top=' + t + ',toolbar=no,scrollbar=yes');

		e.preventDefault();

  };

  return publicMethods;

}();

external.init();
